// Danh sách ngân hàng Việt Nam, lấy từ API công khai VietQR, cache trong bộ
// nhớ vì danh sách gần như không đổi trong 1 phiên làm việc.

let nganHangCache = null;

export const nganHangApi = {
  async danhSach() {
    if (nganHangCache) return nganHangCache;
    const res = await fetch("https://api.vietqr.io/v2/banks");
    if (!res.ok) throw new Error("Không tải được danh sách ngân hàng");
    const json = await res.json();
    nganHangCache = (json.data ?? []).map((b) => ({
      code: b.code,
      name: b.shortName,
      tenDayDu: b.name,
      bin: b.bin,
    }));
    return nganHangCache;
  },
};
